import { AiOutlineCopyright } from "react-icons/ai";
import { Link } from "react-router-dom";
import EULogo from "../../assets/images/EULogo.png";
import { Box, Button, Container, Grid2 } from "@mui/material";
import { Fragment } from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import curveQ from "../../assets/images/curveQ.png";

const Footer = () => {
  return (
    <Fragment>
      <section className="curveBg">
        <Container fixed>
          <Grid2 container spacing={2}>
            <Grid2 size={{ xs: 12, lg: 8 }} className="content">
              <h3>
                What is <span>Minecraft Education?</span>
              </h3>
              <p>
                Visit the official Minecraft Education website to find out more!
              </p>
              <Button
                variant="outlined"
                href="https://education.minecraft.net"
                target="_blank"
              >
                Learn More <ArrowForwardIcon />
              </Button>
            </Grid2>
            <Grid2 size={{ xs: 12 }}>
              <img src={curveQ} alt="What is Minecraft Education?" />
            </Grid2>
          </Grid2>
        </Container>
      </section>
      <footer>
        <Container fixed>
          <Box className="content">
            <span>
              <AiOutlineCopyright /> EU Code Week 2026 - NOT AN OFFICIAL
              MINECRAFT EDUCATION PRODUCT
            </span>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <img src={EULogo} alt="Logo European Union" />
          </Box>
        </Container>
      </footer>
    </Fragment>
  );
};

export default Footer;
